<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>电销短信/促活短信</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 6vh">
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.xiaoqu_id" placeholder="请选择小区" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchClearInput">
							<el-option v-for="item in regionArr" :key="item.id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.action_button" placeholder="行为开关" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchStatusClearInput">
							<el-option v-for="(item,index) in statusList" :key="item.id" :label="item.title" :value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button icon="el-icon-refresh-left" type="warning" @click="clearSearchInput"
							size="small">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="ID" align="center"></el-table-column>
			<el-table-column prop="title" label="小区" align="center"></el-table-column>
			<el-table-column prop="active_sms_count" label="行为触发条数" align="center"></el-table-column>
			<el-table-column prop="market_sms_count" label="营销短信条数" align="center" />
			<el-table-column prop="" label="行为触发" align="center" width="200">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.action_trigger_button" active-value="on" active-color="#13ce66"
						inactive-value="off" @change="changeAction(scope.row)"></el-switch>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getSmsList,
		smsSwitch
	} from "../../api/sms";
	import {
		getcarList
	} from "../../api/garage";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getSmsList,
				},
				// 传参
				form: {},
				statusList: [{
					id: 'on',
					title: '开启'
				}, {
					id: 'off',
					title: '关闭'
				}],
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
					xiaoqu_id: '',
					action_button: ''
				},
				tableData: [],
				regionArr: [],
			};
		},
		mounted() {
			const form = {
				select: 1,
			};
			getcarList(form).then((res) => {
				this.regionArr = res.data.records.filter((item, index, self) => {
					return self.findIndex((t) => t.xiaoqu_id === item.xiaoqu_id) === index;
				});
				this.regionArr.forEach((item, index) => item.xiaoqu_id = item.xiaoqu_id.toString());
				console.log(this.regionArr)
			});
		},
		methods: {
			searchClearInput() {
				this.searchForm.xiaoqu_id = ''
			},
			searchStatusClearInput() {
				this.searchForm.action_button = '';
			},
			clearSearchInput() {
				this.searchForm.xiaoqu_id = '';
				this.searchForm.action_button = '';
				this.searchChange();
			},
			changeAction(row) {
				smsSwitch({xiaoqu_id:row.id,button:row.action_trigger_button}).then(res=>{
					if (res.code == 200) {
						this.$message.success('状态修改成功');
						this.searchChange();
					}else{
						this.$message.error('状态修改失败');
					}
				});
			}
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/actAICallSms/sms.vue